import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"height":"100%","position":"relative"} }
const _hoisted_2 = {
  class: "table columns",
  style: {"gap":"3.5rem"}
}
const _hoisted_3 = {
  class: "col1 col",
  style: {"gap":"1.5rem"}
}
const _hoisted_4 = { class: "row-top" }
const _hoisted_5 = { class: "pad-s" }
const _hoisted_6 = {
  key: 0,
  class: "row-top"
}
const _hoisted_7 = { class: "pad-s" }
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = {
  key: 1,
  class: "row"
}
const _hoisted_10 = {
  key: 2,
  class: "row"
}
const _hoisted_11 = {
  class: "col2 col",
  style: {"gap":"1.5rem"}
}
const _hoisted_12 = { class: "row-top" }
const _hoisted_13 = { class: "pad-s" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "row-top" }
const _hoisted_16 = { class: "pad-s" }
const _hoisted_17 = {
  key: 0,
  class: "row-top"
}
const _hoisted_18 = { class: "pad-s" }
const _hoisted_19 = { class: "row-top" }
const _hoisted_20 = { class: "pad-s" }
const _hoisted_21 = {
  class: "col3 col",
  style: {"gap":"1.5rem"}
}
const _hoisted_22 = {
  key: 0,
  class: "row-top"
}
const _hoisted_23 = { class: "pad-s" }
const _hoisted_24 = {
  key: 0,
  class: "row"
}
const _hoisted_25 = {
  key: 1,
  class: "row-top"
}
const _hoisted_26 = { class: "pad-s" }
const _hoisted_27 = {
  key: 4,
  class: "row"
}
const _hoisted_28 = {
  key: 2,
  class: "row-top"
}
const _hoisted_29 = { class: "pad-s" }
const _hoisted_30 = {
  key: 1,
  class: "row"
}
const _hoisted_31 = {
  key: 2,
  class: "row"
}
const _hoisted_32 = {
  key: 3,
  class: "row"
}
const _hoisted_33 = {
  key: 4,
  class: "row"
}
const _hoisted_34 = { class: "row-top" }
const _hoisted_35 = { class: "pad-s" }
const _hoisted_36 = {
  key: 3,
  class: "row-top"
}
const _hoisted_37 = { class: "pad-s" }
const _hoisted_38 = {
  class: "col4 col",
  style: {"gap":"1.5rem"}
}
const _hoisted_39 = {
  key: 0,
  class: "row-top"
}
const _hoisted_40 = { class: "pad-s" }
const _hoisted_41 = {
  key: 1,
  class: "row-top"
}
const _hoisted_42 = { class: "pad-s" }
const _hoisted_43 = {
  key: 2,
  class: "row-top"
}
const _hoisted_44 = { class: "pad-s" }
const _hoisted_45 = { class: "row-top" }
const _hoisted_46 = { class: "pad-s" }
const _hoisted_47 = {
  key: 3,
  class: "row-top"
}
const _hoisted_48 = { class: "pad-s" }
const _hoisted_49 = {
  key: 5,
  class: "row"
}
const _hoisted_50 = { class: "col5 col thin-gap" }
const _hoisted_51 = { class: "row-top" }
const _hoisted_52 = {
  class: "table columns mtop-10",
  style: {"gap":"3.5rem"}
}
const _hoisted_53 = { class: "col gap-04" }
const _hoisted_54 = { class: "col gap-04" }
const _hoisted_55 = { class: "col gap-04" }
const _hoisted_56 = { class: "col gap-04" }

import editAppUserPreferences from '@/views/patientMain/editAppUserPreferences.vue'
import { ref, computed, onMounted, nextTick } from 'vue'
import patientapi from "@/api/patientapi"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { apiDate } from "@/api/apicommon"
import { useAppUserStore } from '@/stores/appUser'
import { useI18n } from "vue-i18n";
import { differenceInMilliseconds } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'addHistory',
  emits: ['added'],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const { t } = useI18n();
const appUserStore = useAppUserStore()
const currentEntryStore = useCurrentEntryStore()
const focus = ref(null)
const dropd = ref(null)

const contentText = ref("")

const isFemale = computed(() => {
  return currentEntryStore.currentPatient.biologicalSex === 'Female'
})

const isMale = computed(() => {
  return currentEntryStore.currentPatient.biologicalSex === 'Male'
})

const is0to5 = computed(() => {
  return patientAge.value < 5
})

const is5to15 = computed(() => {
  return patientAge.value >= 5 && patientAge.value < 15
})

const is15to49 = computed(() => {
  return patientAge.value >= 15 && patientAge.value < 50
})

const is50to69 = computed(() => {
  return patientAge.value >= 50 && patientAge.value < 70
})

const is70plus = computed(() => {
  return patientAge.value >= 70
})

const patientAge = computed(() => {
  const entryDate = apiDate(currentEntryStore.currentEntryDate)
  const birthDate = apiDate(currentEntryStore.currentPatient.birthDate)
  const timeDifference = differenceInMilliseconds(entryDate, birthDate); 
  const years = timeDifference / (365 * 24 * 60 * 60 * 1000)
  return years
})

function toInput(txt: string) {
  if (!contentText.value.endsWith(' ')) {contentText.value += ' '}
  contentText.value += txt + ' '
  focus.value.innerRef.focus()
}

function toInputAsDouble(suggestionPart1: string, suggestionPart2: string) {
  let existingText = contentText.value
  if (!existingText.endsWith(' ')) {existingText += ' '}
  if (!suggestionPart1.endsWith(' ')) {suggestionPart1 += ' '}
  if (!suggestionPart2.startsWith(' ')) {suggestionPart2 = ' ' + suggestionPart2}
  const focusIndex = existingText.length + suggestionPart1.length
  existingText += suggestionPart1 + suggestionPart2 + ' '
  //Update values
  contentText.value = existingText
  //Focus
  focus.value.innerRef.focus()
  nextTick(() => {
      focus.value.innerRef.setSelectionRange(focusIndex, focusIndex)
  })
}

function startWithNewText(newText: string) {
  contentText.value = newText ? newText + ' ' : ''
  focus.value.innerRef.focus()
}

async function createFCT() {
  const entryId = currentEntryStore.currentEntryId;
  const newText = contentText.value.trim();
  if (!newText) return;
  contentText.value = "";
  await patientapi.addAtcd(newText, entryId);
  emits('added');
  currentEntryStore.reloadAfterHistoryChange();
}

onMounted(() => {
  focus.value.innerRef.focus()
});

return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bg-modal w-maxC",
      style: {"position":"absolute","bottom":"0","right":"0","cursor":"auto"},
      onClick: _cache[103] || (_cache[103] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_svg_item, {
                icon: "brain",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              (is50to69.value || is70plus.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 0,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.stroke'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.stroke')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is70plus.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 1,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.dementia'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.dementia')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is70plus.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 2,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.parkinson'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.parkinson')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is0to5.value || is5to15.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 3,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.epilepsy'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.epilepsy')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is5to15.value || is15to49.value ||is50to69.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 4,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.migraine'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.migraine')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is5to15.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 5,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.adhd'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.adhd')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is15to49.value || is50to69.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 6,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.depressiveDisorder'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.depressiveDisorder')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (patientAge.value > 10 && (is5to15.value || is15to49.value || is50to69.value))
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 7,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.anxietyDisorder'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.anxietyDisorder')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is15to49.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 8,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.bipolarDisorder'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.bipolarDisorder')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is15to49.value || is50to69.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 9,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.addictionTo'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.addictionTo')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isFemale.value && patientAge.value > 12 && is5to15.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 10,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.anorexia'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.anorexia')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isFemale.value && patientAge.value > 9 && is5to15.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 11,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.bulimia'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.bulimia')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is0to5.value || is5to15.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 12,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.autisticDisorder'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.autisticDisorder')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is15to49.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 13,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.schizophrenia'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.schizophrenia')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          (!is0to5.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_svg_item, {
                    icon: "eye",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (is5to15.value || is15to49.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.refractionDisorders'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.refractionDisorders')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.refractionDisordersRightEye'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.refractionDisordersLeftEye'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.cataract'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.cataract')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.cataractRightEye'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.cataractLeftEye'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.glaucoma'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.glaucoma')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.glaucomaRightEye'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.glaucomaLeftEye'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_svg_item, {
                icon: "ear",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              (is50to69.value || is70plus.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_button_group, {
                      styles: "pad-s",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hearingLoss'))))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.addHistory.hearingLoss')
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_button_group, {
                      styles: "pad-s",
                      class: "leftRight",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hearingLossRightEar'))))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.addHistory.rightAbbr'),
                          class: "main-l"
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_button_group, {
                      styles: "pad-s",
                      class: "leftRight",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hearingLossLeftEar'))))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.addHistory.leftAbbr'),
                          class: "main-l"
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (is70plus.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 1,
                    styles: "pad-s",
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.edentulism'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.edentulism')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.adenoidectomy'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addHistory.adenoidectomy')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }),
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.tonsillectomy'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addHistory.tonsillectomy')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_svg_item, {
                icon: "lung",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              (is50to69.value || is70plus.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 0,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.copd'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.copd')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is0to5.value || is5to15.value || is15to49.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 1,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.asthma'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.asthma')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          (is0to5.value || is50to69.value || is70plus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_svg_item, {
                    icon: "heart",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (is0to5.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.congenitalHeartDefect'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.congenitalHeartDefect')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 1,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.coronaryArteryDisease'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.coronaryArteryDisease')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 2,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hypertensiveHeartDisease'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.hypertensiveHeartDisease')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 3,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.atrialFibrillation'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.atrialFibrillation')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 4,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.valvularHeartDisease'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.valvularHeartDisease')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 5,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.venousInsufficiency'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.venousInsufficiency')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_svg_item, {
                icon: "stomach",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              (is15to49.value || is50to69.value || is70plus.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 0,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[37] || (_cache[37] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hepaticSteatosis'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.hepaticSteatosis')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is50to69.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 1,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[38] || (_cache[38] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.cirrhosis'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.cirrhosis')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[39] || (_cache[39] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.appendectomy'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addHistory.appendectomy')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }),
              (is15to49.value || is50to69.value || is70plus.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 2,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.cholecystectomy'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.cholecystectomy')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          (is0to5.value || is15to49.value || is50to69.value || is70plus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_svg_item, {
                    icon: "kidney",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (is0to5.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          onClick: _cache[41] || (_cache[41] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.malformativeUropathy'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.malformativeUropathy')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[42] || (_cache[42] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.malformativeUropathyRight'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[43] || (_cache[43] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.malformativeUropathyLeft'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 1,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[44] || (_cache[44] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.renalInsufficiency'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.renalInsufficiency')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is15to49.value || is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 2,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[45] || (_cache[45] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.renalLithiasis'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.renalLithiasis')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isMale.value && (is50to69.value || is70plus.value))
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 3,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.benignProstaticHyperplasia'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.benignProstaticHyperplasia')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (isFemale.value && (is15to49.value || is50to69.value || is70plus.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_svg_item, {
                    icon: "uterus",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (is15to49.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[47] || (_cache[47] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.pregnancy'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.pregnancy')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 1,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[48] || (_cache[48] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.menopause'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.menopause')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is15to49.value || is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 2,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[49] || (_cache[49] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.cesareanSection'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.cesareanSection')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is15to49.value || is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 3,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[50] || (_cache[50] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hysterectomy'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.hysterectomy')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is15to49.value || is50to69.value || is70plus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[51] || (_cache[51] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.oophorectomy'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.oophorectomy')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[52] || (_cache[52] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.oophorectomyRight'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[53] || (_cache[53] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.oophorectomyLeft'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (is5to15.value || is50to69.value || is70plus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_svg_item, {
                    icon: "bone",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (is5to15.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[54] || (_cache[54] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.scoliosis'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.scoliosis')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          onClick: _cache[55] || (_cache[55] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hipOsteoarthritis'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.hipOsteoarthritis')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[56] || (_cache[56] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hipOsteoarthritisRight'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[57] || (_cache[57] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hipOsteoarthritisLeft'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          onClick: _cache[58] || (_cache[58] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.kneeOsteoarthritis'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.kneeOsteoarthritis')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[59] || (_cache[59] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.kneeOsteoarthritisRight'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[60] || (_cache[60] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.kneeOsteoarthritisLeft'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          onClick: _cache[61] || (_cache[61] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hipProsthesis'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.hipProsthesis')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[62] || (_cache[62] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hipProsthesisRight'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[63] || (_cache[63] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hipProsthesisLeft'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          onClick: _cache[64] || (_cache[64] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.kneeProsthesis'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.kneeProsthesis')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[65] || (_cache[65] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.kneeProsthesisRight'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[66] || (_cache[66] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.kneeProsthesisLeft'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_svg_item, {
                icon: "skin",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              (is0to5.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 0,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[67] || (_cache[67] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.atopicDermatitis'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.atopicDermatitis')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (patientAge.value > 13 && patientAge.value < 25)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 1,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[68] || (_cache[68] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.acne'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.acne')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (is5to15.value || is15to49.value || is50to69.value || is70plus.value)
                ? (_openBlock(), _createBlock(_component_button_group, {
                    key: 2,
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[69] || (_cache[69] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.psoriasis'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.psoriasis')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          ((isFemale.value && is15to49.value) || is50to69.value || is70plus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_svg_item, {
                    icon: "endoc",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (isFemale.value && (is15to49.value || is50to69.value || is70plus.value))
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[70] || (_cache[70] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hypothyroidism'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.hypothyroidism')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 1,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[71] || (_cache[71] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hyperparathyroidism'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.hyperparathyroidism')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_38, [
          (is15to49.value || is50to69.value || is70plus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_svg_item, {
                    icon: "pressure",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (is15to49.value || is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[72] || (_cache[72] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hypertension'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.hypertension')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (is15to49.value || is50to69.value || is70plus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_svg_item, {
                    icon: "biochemical",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (is15to49.value || is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[73] || (_cache[73] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.diabetes'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.diabetes')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is15to49.value || is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 1,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[74] || (_cache[74] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.dyslipidemia'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.dyslipidemia')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isMale.value && (is50to69.value || is70plus.value))
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 2,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[75] || (_cache[75] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.hyperuricemia'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.hyperuricemia')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (!is0to5.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_svg_item, {
                    icon: "infectious",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (is5to15.value || is15to49.value || is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[76] || (_cache[76] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.bacterialPneumonia'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.bacterialPneumonia')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isFemale.value && (is15to49.value))
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 1,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[77] || (_cache[77] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.toxoplasmosis'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.toxoplasmosis')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_svg_item, {
                icon: "immunity",
                styles: "main-m size-l"
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_button_group, {
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[78] || (_cache[78] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.allergy'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addHistory.allergy')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ])
          ]),
          (is15to49.value || is50to69.value || is70plus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_svg_item, {
                    icon: "cancer",
                    styles: "main-m size-l"
                  })
                ]),
                _createElementVNode("div", null, [
                  (is15to49.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[79] || (_cache[79] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.brainCancer'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.brainCancer')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 1,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[80] || (_cache[80] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.lungCancer'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.lungCancer')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 2,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[81] || (_cache[81] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.colonCancer'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.colonCancer')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (is50to69.value || is70plus.value)
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 3,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[82] || (_cache[82] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.pancreaticCancer'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.pancreaticCancer')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isMale.value && (is50to69.value || is70plus.value))
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 4,
                        styles: "pad-s",
                        class: "leftRight",
                        onClick: _cache[83] || (_cache[83] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.prostateCancer'))))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.addHistory.prostateCancer')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isFemale.value && (patientAge.value > 30))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[84] || (_cache[84] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.breastCancer'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.breastCancer')
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[85] || (_cache[85] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.breastCancerRight'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.rightAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_button_group, {
                          styles: "pad-s",
                          class: "leftRight",
                          onClick: _cache[86] || (_cache[86] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.breastCancerLeft'))))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.addHistory.leftAbbr'),
                              class: "main-l"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_button_group, {
                    styles: "pad-s",
                    class: "leftRight",
                    onClick: _cache[87] || (_cache[87] = ($event: any) => (startWithNewText(_unref(t)('patient.addHistory.leukemia'))))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.addHistory.leukemia')
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((dropd).value = $event)),
              openOn: "RbHistory"
            }, {
              dropd: _withCtx(() => [
                _createVNode(editAppUserPreferences, {
                  title: _unref(t)('patient.addHistory.favorites'),
                  referenceTextType: "RbHistory",
                  dtoKey: "rbHistory"
                }, null, 8, ["title"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_button_group, { class: "pad-s" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "star",
                      styles: "main-h size-l",
                      class: "txt-primary"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appUserStore).currentAppUserData?.preferences?.rbHistory.split('\n'), (suggestion, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  suggestion
                    ? (_openBlock(), _createBlock(_component_button_group, {
                        key: 0,
                        styles: "pad-s",
                        class: "psides-05",
                        onClick: ($event: any) => (startWithNewText(suggestion))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, { txt: suggestion }, null, 8, ["txt"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ])
      ]),
      _cache[105] || (_cache[105] = _createElementVNode("div", { class: "line-h mtop-10" }, null, -1)),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[89] || (_cache[89] = ($event: any) => (toInput(_unref(t)('patient.addHistory.left'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addHistory.left')
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[90] || (_cache[90] = ($event: any) => (toInput(_unref(t)('patient.addHistory.right'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addHistory.right')
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[91] || (_cache[91] = ($event: any) => (toInput(_unref(t)('patient.addHistory.in'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addHistory.in') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[92] || (_cache[92] = ($event: any) => (toInputAsDouble(_unref(t)('patient.addHistory.yearsAgo'), _unref(t)('patient.addHistory.years'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addHistory.yearsAgo') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[93] || (_cache[93] = ($event: any) => (toInputAsDouble(_unref(t)('patient.addHistory.atAge'), _unref(t)('patient.addHistory.years'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addHistory.atAge') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          (is15to49.value || is50to69.value || is70plus.value)
            ? (_openBlock(), _createBlock(_component_button_group, {
                key: 0,
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[94] || (_cache[94] = ($event: any) => (toInput(_unref(t)('patient.addHistory.inChildhood'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addHistory.inChildhood')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[95] || (_cache[95] = ($event: any) => (toInput(_unref(t)('patient.addHistory.since'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addHistory.since') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[96] || (_cache[96] = ($event: any) => (toInputAsDouble(_unref(t)('patient.addHistory.sinceAge'), _unref(t)('patient.addHistory.years'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addHistory.sinceAge') + ' ...'
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          (is15to49.value || is50to69.value || is70plus.value)
            ? (_openBlock(), _createBlock(_component_button_group, {
                key: 0,
                styles: "pad-s",
                class: "leftRight",
                onClick: _cache[97] || (_cache[97] = ($event: any) => (toInput(_unref(t)('patient.addHistory.sinceChildhood'))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.addHistory.sinceChildhood')
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[98] || (_cache[98] = ($event: any) => (toInput(_unref(t)('patient.addHistory.fatherSide'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addHistory.fatherSide')
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_button_group, {
            styles: "pad-s",
            class: "leftRight",
            onClick: _cache[99] || (_cache[99] = ($event: any) => (toInput(_unref(t)('patient.addHistory.motherSide'))))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.addHistory.motherSide')
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_inputComboBox2, {
        ref_key: "focus",
        ref: focus,
        class: "mtop-15 w-full",
        modelValue: contentText.value,
        "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((contentText).value = $event)),
        onKeyup: _cache[102] || (_cache[102] = _withKeys(($event: any) => (createFCT()), ["enter"])),
        hasDropd: false
      }, {
        post: _withCtx(() => [
          _cache[104] || (_cache[104] = _createElementVNode("div", { class: "line-v" }, null, -1)),
          _createVNode(_component_buttonGroup, {
            theme: "inline",
            onClick: _cache[100] || (_cache[100] = ($event: any) => (createFCT()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "check",
                styles: "size-l"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})